import React, { useState } from "react";
import * as Components from "../../../components/all";
import { useParams } from "react-router-dom";

export default function User() {
	const params = useParams();
	const [loading, setLoading] = useState(false);

	// generate Password
	function generatePassword() {
		var chars =
			"0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
		var passwordLength = 12;
		var pass = "";
		for (var i = 0; i <= passwordLength; i++) {
			var randomNumber = Math.floor(Math.random() * chars.length);
			pass += chars.substring(randomNumber, randomNumber + 1);
		}

		setPassword(pass);
	}

	// New Admin
	const [password, setPassword] = useState(null);

	// Functions
	const updatePassword = () => {
		if (password === null || password.length < 8) {
			alert("Password must have atleast 8 characters !");
			return;
		}

		var choice = prompt(
			"Confirm the password, if you want to update password:"
		);
		if (choice === password) {
		}
	};

	return loading === true ? (
		<Components.Loader />
	) : (
		<div
			className="PasswordReset
            overflow-x-hidden overflow-y-auto 
            h-full
            w-full
            sm:p-3 md:p-5
            flex flex-col
            "
		>
			{/* TOP CARDS ROW */}
			<div className="TOP-CARDS flex flex-1">
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[450px]
					sm:min-w-[350px] flex-1
                    p-5 m-2
					overflow-hidden
                    rounded-md
                    bg-white 
                    flex flex-col
                    duration-150 ease-in-out
                    "
				>
					{/* heading */}
					<div
						className="
							w-full
							p-2 pt-0 
							flex 
							items-center justify-between 
							flex-wrap
							"
					>
						<div className="flex items-center">
							<Components.BackButton />
							<h1 className="ml-2 text-darker">Password Reset</h1>
						</div>
					</div>

					{/* data */}
					<div
						className="
                            flex-1
                            flex flex-col justify-center
                            w-full sm:w-[50%] md:w-[40%] mx-auto
                            "
					>
						<div className="flex border border-[#CCCCCC] rounded overflow-hidden">
							<input
								type="text"
								placeholder="Password"
								className="text-sm rounded px-2 py-1 focus:outline-none flex-1 
									max-sm:w-[70%]"
								onChange={(e) => setPassword(e.target.value)}
								value={password}
							/>

							<button
								className="text-sm text-darker font-medium rounded   
									sm:px-2 sm:ml-2 focus:outline-none
									max-sm:w-[30%]
									max-sm:text-center
									"
								onClick={() => generatePassword()}
							>
								Generate
							</button>
						</div>

						{/* button */}
						<button
							className="mt-8 mx-auto bg-main w-fit px-5 py-1 rounded text-white font-medium
                            duration-300 ease-in-out
                            hover:opacity-70
                            "
							onClick={() => updatePassword()}
						>
							Update Password
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
